import { AfterViewInit, OnDestroy, Component, OnInit } from '@angular/core';
import { Course } from 'src/app/models/course.model';
import { Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AngularFirestore } from '@angular/fire/firestore';
import { ActivatedRoute, Router } from '@angular/router';
import { HomeData } from 'src/app/models/home-data.model';
import { CombineLatestSubscriber } from 'rxjs/internal/observable/combineLatest';
import { Teacher } from 'src/app/models/teacher.model';
import { HomeService } from 'src/app/services/home.service';
import { Knowledge } from 'src/app/models/knowledge.model';
import { EnglishCourse } from 'src/app/models/english-course';
import { Partner } from 'src/app/models/partner.model';
import { Translate, getLocalTranslate } from 'src/app/helpers/global-functions'
import { Setting } from 'src/app/models/setting.model';
import { SafeUrl, DomSanitizer } from '@angular/platform-browser';
import { Title } from '@angular/platform-browser';

declare var $: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  showSpinner: boolean = false

  courses: Course[] = []

  teachers: Teacher[] = []

  knowledges: Knowledge[] = []

  englishCourses: EnglishCourse[] = []

  partners: Partner[] = []

  bubbleImage: string = ''

  slideTitle:string = ''
  slideTitleHeader:string = ''
  slideDesc:string = ''
  viewCourses:string = ''
  getStartFree:string = ''

  discoverCourses: string = 'Discover Courses'
  popularCourses: string = 'Our Popular Online Courses'
  allCourses: string = 'Our Popular Online Courses'
  englishLessonsCourses: string = 'English Lesson Courses'
  browseTrendingCourses: string = 'Browse Trending Courses'
  viewAll: string = 'View All'
  ourPartner: string = 'Our Company & Partners'
  makeConnections: string = 'Make Connections'
  teamInstructor: string = 'Team of Instructors'
  allInstructor: string = 'Meet All Instructor'
  exploreNews: string = 'Explore News'
  latestKnowledges: string = 'Our Latest Knowledges'
  readAll: string = 'Read All'
  provideResources: string = ''
  provideResourcesText: string = ''
  empowerLearner: string = ''
  empowerLearnerText: string = ''
  thinkBig: string = ''
  thinkBigText: string = ''
  slideBackgroundUrl: SafeUrl;
  translate: any = (en:string, km:string) => Translate(en, km);

  setting: Setting

  background:SafeUrl

  constructor(
    private firestore: AngularFirestore,
    private route: ActivatedRoute,
    private homeService: HomeService,
    private router: Router,
    private sanizer: DomSanitizer,
    private titleService: Title
  ) { }

  private slider: any;

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.initMissionSlider();
    }, 300);
  }

  initMissionSlider(): void {
    this.slider = $('.mission-slides');

    if (!this.slider.length) {
      return;
    }

    // Prevent duplicate initialization
    if (this.slider.hasClass('owl-loaded')) {
      this.slider.trigger('destroy.owl.carousel');
    }

    this.slider.owlCarousel({
      loop: true,
      nav: true,
      dots: false,
      autoplayHoverPause: true,
      autoplay: true,
      items: 1,
      navText: [
        "<i class='bx bx-left-arrow-alt'></i>",
        "<i class='bx bx-right-arrow-alt'></i>"
      ]
    });
  }

  ngOnDestroy(): void {
    if (this.slider && this.slider.hasClass('owl-loaded')) {
      this.slider.trigger('destroy.owl.carousel');
    }
  }

  ngOnInit() {
    this.needTranslate()
    this.getHomeData()
    this.getSetting()
    this.titleService.setTitle("CamEdu")
  }

  getHomeData() {
    this.showSpinner = true
    this.homeService.getHomeData().subscribe(result => {
      this.courses = result.courses
      this.teachers = result.teachers
      this.prepareKnowledges(result.knowledges)
      this.prepareenglishCourses(result.englishCourses)
      this.partners = result.partners
      this.showSpinner = false
    })
  }

  prepareKnowledges(data:any){
    this.knowledges = data
    if(this.knowledges.length < 3){
      return
    }
    const newDatas:Knowledge[] = []
    const useIndex:any[] = []
    for (let i = 0; i < 3; i++) {
      const index = this.getRandomIndex(useIndex,this.knowledges.length)
      useIndex.push(index)
    }
    useIndex.forEach(index => {
      newDatas.push(this.knowledges[index])
    });
    this.knowledges = newDatas.sort((a, b) => (a.updatedAt > b.updatedAt ? -1 : 1));
  }
  prepareenglishCourses(data:any){
    this.englishCourses = data
    if(this.englishCourses.length < 3){
      return
    }
    const newDatas:EnglishCourse[] = []
    const useIndex:any[] = []
    for (let i = 0; i < 3; i++) {
      const index = this.getRandomIndex(useIndex,this.englishCourses.length)
      useIndex.push(index)
    }
    useIndex.forEach(index => {
      newDatas.push(this.englishCourses[index])
    });
    this.englishCourses = newDatas.sort((a, b) => (a.createdAt > b.createdAt ? -1 : 1));
  }

  getRandomIndex(usedIndexs, maxIndex) {
    var result = 0;
    var min = 0;
    var max = maxIndex - 1;
    var index = Math.floor(Math.random()*(max-min+1)+min);

    while(usedIndexs.indexOf(index) > -1) {
        if (index < max) {
            index++;
        } else {
          index = 0;
        }
    }

    return index;
}

  getSetting() {
    this.homeService.getSetting().then(result => {
      this.setting = result as Setting
      this.background= this.sanizer.bypassSecurityTrustStyle(`url(${this.setting.slideBackgroundImage.fileUrl}) no-repeat`);
    })
  }

  needTranslate() {
    this.discoverCourses = getLocalTranslate('discover-courses', this.discoverCourses)
    this.popularCourses = getLocalTranslate('our-popular-online-courses', this.popularCourses)
    this.allCourses = getLocalTranslate('all-courses', this.allCourses)
    this.englishLessonsCourses = getLocalTranslate('discover-courses', this.englishLessonsCourses)
    this.browseTrendingCourses = getLocalTranslate('browse-trending-courses', this.browseTrendingCourses)
    this.viewAll = getLocalTranslate('view-all', this.viewAll)
    this.ourPartner = getLocalTranslate('our-company-partners', this.ourPartner)
    this.makeConnections = getLocalTranslate('make-connections', this.makeConnections)
    this.teamInstructor = getLocalTranslate('team-instructors', this.teamInstructor)
    this.allInstructor = getLocalTranslate('all-instructor', this.allInstructor)
    this.exploreNews = getLocalTranslate('explore-news', this.exploreNews)
    this.latestKnowledges = getLocalTranslate('latest-knowledges', this.latestKnowledges)
    this.readAll = getLocalTranslate('read-all', this.readAll)
    this.provideResources = getLocalTranslate('provide-resources', this.provideResources)
    this.provideResourcesText = getLocalTranslate('provide-resources-text', this.provideResourcesText)
    this.empowerLearner = getLocalTranslate('empower-learners', this.empowerLearner)
    this.empowerLearnerText = getLocalTranslate('empower-learners-text', this.empowerLearnerText)
    this.thinkBig = getLocalTranslate('think-big', this.thinkBig)
    this.thinkBigText = getLocalTranslate('think-big-text', this.thinkBigText)
    // Slide
    this.slideTitle = getLocalTranslate('slide-title','')
    this.slideTitleHeader = getLocalTranslate('slide-title-header','')
    this.slideDesc = getLocalTranslate('slide-desc','')
    this.viewCourses = getLocalTranslate('view-courses','')
    this.getStartFree = getLocalTranslate('get-started-free','')
  }

  routeToCourseDetail(id: string) {
    this.router.navigate(['/course/' + id]);
  }

  routeToTeacherDetail(id: string) {
    this.router.navigate(['/instructor/' + id]);
  }

}
